import { render } from "./DataJemaat.vue?vue&type=template&id=0e3dec6e"
import script from "./DataJemaat.vue?vue&type=script&lang=js"
export * from "./DataJemaat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__